import Skeleton from "./Skeleton"

export default function CustomsLoading({}) {
  return (
    <div className="flex flex-1 flex-col px-4">
      <div className="my-3 flex justify-between">
        <div>
          <Skeleton w={130} h={32} style="mb-3" />
          <Skeleton w={280} h={40} style="mt-3" />
        </div>
        <Skeleton w={90} h={60} />
      </div>
      <Skeleton h={36} />
      <Skeleton w={100} h={32} style="my-3" />
      <Skeleton h={200} />
      <Skeleton w={200} h={32} style="my-3" />
      <Skeleton h={200} />
    </div>
  )
}
